import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "document-card-option-place" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "d-flex mb-12" }
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 1,
  class: "document-card-business-function transparent-bg hidden"
}
const _hoisted_6 = { class: "document-card-edited p3 grey-1 d-flex align-items-center" }
const _hoisted_7 = {
  style: {"padding":"10px 0"},
  class: "ml-10"
}
const _hoisted_8 = { style: {"margin-bottom":"0"} }
const _hoisted_9 = { class: "progress-value" }
const _hoisted_10 = { style: {"margin-bottom":"0"} }
const _hoisted_11 = { class: "progress-value" }
const _hoisted_12 = { class: "last-edited-wrapper" }
const _hoisted_13 = { class: "last-edited-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_delete_svg = _resolveComponent("delete-svg")!
  const _component_option_drop_down_row = _resolveComponent("option-drop-down-row")!
  const _component_option_drop_down = _resolveComponent("option-drop-down")!
  const _component_Progress_bar = _resolveComponent("Progress-bar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'document-card': true,
      'document-card-small': _ctx.isCardTypeSmall,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_option_drop_down, null, {
        default: _withCtx(() => [
          _createVNode(_component_option_drop_down_row, {
            text: "Unarchive",
            onHandleClick: _ctx.unarchiveCard
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_delete_svg)
            ]),
            _: 1
          }, 8, ["onHandleClick"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "document-card-name heading-5 black mb-10",
        title: _ctx.name
      }, _toDisplayString(_ctx.name), 9, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.getBusinessFunction(_ctx.filterValues))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              title: _ctx.getBusinessFunction(_ctx.filterValues),
              class: "document-card-business-function"
            }, _toDisplayString(_ctx.getBusinessFunction(_ctx.filterValues)), 9, _hoisted_4))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, " "))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Progress_bar, { progress: _ctx.progress }, null, 8, ["progress"]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "progress-label" }, "Answered:", -1)),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("b", _hoisted_9, _toDisplayString(_ctx.document.answers_progress), 1)
        ]),
        _createElementVNode("p", _hoisted_10, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "progress-label" }, "Total question:", -1)),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("b", _hoisted_11, _toDisplayString(_ctx.document.answers_progress), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("span", _hoisted_13, "Last edited: " + _toDisplayString(_ctx.format(new Date(_ctx.lastEdited), "MMM d, yyyy")), 1)
    ])
  ], 2))
}